// @/utils/pdf-download.js
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export async function downloadPDF(module, id, customFileName = null) {
  const toast = useToast();

  try {
    const response = await axios.get(`/${module}/${id}/pdf`, {
      responseType: 'blob'
    });

    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = fileURL;

    const safeName = customFileName
      ? customFileName.replace(/[\\/]/g, '-')
      : `${module}_${id}`;
    link.download = `${safeName}.pdf`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(fileURL);
  } catch (error) {
    toast.error("Failed to download PDF");
    console.error(error);
  }
}
